import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import Table from "../../core/common/dataTable/index";
import DeleteModal from "../../core/modals/deleteModal";
import useApi from "../../core/customhook/useApi";
import Swal from "sweetalert2";

const PMSCategory = () => {
  const [allItemList, setAllItemList] = useState<any[]>([]);
  const [count, setCount] = useState(1);
  const [newItem, setNewItem] = useState<any>({
    category_id: "",
    category_name: "",
    description: "",
  });

  const getInputData = (e: any) => {
    const { name, value } = e.target;
    setNewItem({ ...newItem, [name]: value });
  };
  const formatFinancialYear = (year: number) => {
    const nextYearShort = (year + 1).toString().slice(-2);
    return `${year}-${nextYearShort}`;
  };

  const getCurrentFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    const fyStart = month >= 3 ? year : year - 1;
    return formatFinancialYear(fyStart);
  };
  const [finance_year, setFinance_year] = useState(getCurrentFinancialYear());
  const [selectedItem, setSelectedItem] = useState<any>({});
  const [errors, setErrors] = useState<any>({});

  const columns = [
    {
      title: "Sr No.",
      dataIndex: "SrNo",
      render: (text: string, record: any, index: number) => (
        <h6 className="fw-medium fs-14 text-dark">{index + 1}</h6>
      ),
      sorter: false,
    },
    {
      title: "Category",
      dataIndex: "category_name",
      render: (text: string, record: any, index: number) => <p>{text}</p>,
      sorter: (a: any, b: any) => a.category.localeCompare(b.category),
    },
    {
      title: "Description",
      dataIndex: "category_description",
      sorter: (a: any, b: any) => a.description.localeCompare(b.description),
    },
    {
      title: "Created By",
      dataIndex: "manager_id",
      sorter: (a: any, b: any) => a.createdBy.localeCompare(b.createdBy),
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      render: (text: string, record: any) => (
        <span className={``} style={{ width: "120px" }}>
          {text.split("T")[0]}
        </span>
      ),
      sorter: (a: any, b: any) =>
        new Date(a.createdDate || 0).getTime() -
        new Date(b.createdDate || 0).getTime(),
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (_: any, record: any) => (
        <div className="action-icon d-inline-flex">
          <Link
            to="#"
            className="me-2"
            data-bs-toggle="modal"
            data-bs-target="#edit_category"
            onClick={() => {
              setNewItem({
                category_id: record.category_id,
                category_name: record.category_name,
                description: record.category_description,
              });
            }}
          >
            <i className="ti ti-edit" />
          </Link>
          <Link
            to="#"
            className="me-2"
            onClick={() => {
              DeleteItem(record.category_id);
            }}
          >
            <i className="ti ti-trash" />
          </Link>
        </div>
      ),
    },
  ];

  const {
    data: getcategoryResponse,
    loading: getCategoryLoading,
    error: getCategoryError,
  } = useApi("/api/manager/view-category", {
    method: "POST",
    payload: {
      financial_year: finance_year,
    },
    autoCall: true,
    dependencies: [count],
  });

  useEffect(() => {
    setAllItemList(getcategoryResponse?.data);
  }, [getcategoryResponse]);

  const {
    data: categoryResponse,
    loading: postCategoryLoading,
    error: postCategoryError,
    callApi: postCategoryData,
  } = useApi("/api/manager/add-category", {
    method: "POST",
    autoCall: false,
  });

  const AddNewItem = async (e: any) => {
    e.preventDefault();
    const payload = {
      category_name: newItem.category_name,
      category_description: newItem.description,
    };
    try {
      const response = await postCategoryData(payload);
      if (response.success) {
        Swal.fire({
          title: "Success!",
          text: response?.message || "Category has been added successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });
        document.getElementById("close_modal")?.click();
        setCount(count + 1);
        setNewItem({
          category_id: "",
          category_name: "",
          description: "",
        });
      }
    } catch (error) {
      console.error("Error while adding :", error);
      Swal.fire({
        title: "Error!",
        text: "There was a problem adding the category.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const {
    data: editcategoryResponse,
    loading: editCategoryLoading,
    error: editCategoryError,
    callApi: editCategoryData,
  } = useApi("/api/manager/edit-category", {
    method: "POST",
    autoCall: false,
  });

  const UpdateItemData = async (e: any) => {
    e.preventDefault();
    const payload = {
      category_id: newItem.category_id,
      category_name: newItem.category_name,
      category_description: newItem.description,
    };
    try {
      const response = await editCategoryData(payload);
      if (response.success) {
        Swal.fire({
          title: "Success!",
          text: response?.message || "Category has been update successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });
        document.getElementById("edit_close_modal")?.click();
        setCount(count + 1);
      }
    } catch (error) {
      console.error("Error while updating :", error);
      Swal.fire({
        title: "Error!",
        text: "There was a problem adding the category.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const {
    data: deletecategoryResponse,
    loading: deleteCategoryLoading,
    error: deleteCategoryError,
    callApi: deleteCategoryData,
  } = useApi("", {
    method: "DELETE",
    autoCall: false,
  });
  const DeleteItem = async (ID: any) => {
    const confirmResult = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this Goal Profile? This action cannot be undone. ",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#2e3294",
      cancelButtonColor: "#f79622",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (confirmResult.isConfirmed) {
      try {
        const response = await deleteCategoryData(
          undefined,
          "/api/manager/delete-category/" + ID
        );

        if (response.success) {
          Swal.fire({
            title: "Deleted!",
            text:
              response?.message || "Category has been deleted successfully.",
            icon: "success",
            confirmButtonText: "OK",
          });
          setCount(count + 1);
        }
      } catch (error) {
        console.error("Error while deleting:", error);
        Swal.fire({
          title: "Error!",
          text: "There was a problem deleting the category.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    }
  };

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Goal Profiles</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Work & Operations</li>
                  <li className="breadcrumb-item">Goal Settings</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Goal Profile
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap gap-2">
              <div className="input-icon w-120 position-relative mb-2">
                <select
                  value={finance_year}
                  onChange={(e) => setFinance_year(e.target.value)}
                  className="form-select"
                >
                  {(() => {
                    const today = new Date();
                    const currentYear =
                      today.getMonth() >= 3
                        ? today.getFullYear()
                        : today.getFullYear() - 1;

                    return Array.from({ length: 1 }, (_, i) => {
                      const year = currentYear - i;
                      const nextYearShort = String(year + 1).slice(-2);
                      const financialYear = `${year}-${nextYearShort}`;

                      return (
                        <option key={financialYear} value={financialYear}>
                          {financialYear}
                        </option>
                      );
                    });
                  })()}
                </select>
              </div>
              <div className="mb-2">
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#add_category"
                  className="btn btn-primary custom_button d-flex align-items-center"
                >
                  <i className="ti ti-circle-plus me-2" />
                  Add Goal Profile
                </Link>
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Performance Indicator list */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Goal Profile List</h5>
            </div>
            <div className="card-body p-0">
              <Table
                dataSource={allItemList}
                columns={columns}
                Selection={false}
              />
            </div>
          </div>
          {/* /Performance Indicator list */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
          <p className="mb-0">
            © {new Date().getFullYear()} WeConnect. All rights reserved.
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}

      {/* Add Modal */}
      <div className="modal fade" id="add_category">
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title text-capitalize">Add Goal Profile </h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="close_modal"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={AddNewItem}>
              <div className="modal-body pb-0">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Name<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        name="category_name"
                        onChange={getInputData}
                        value={newItem.category_name}
                        className="form-control"
                        placeholder="Goal Profile Name...."
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Description<span className="text-danger">*</span>
                      </label>
                      <textarea
                        name="description"
                        onChange={getInputData}
                        value={newItem.description}
                        className="form-control"
                        placeholder="Description...."
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  // data-bs-dismiss="modal"
                  className="btn btn-primary custom_button"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Edit Modal */}
      <div className="modal fade" id="edit_category">
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title text-capitalize">Edit Goal Profile</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="edit_close_modal"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={UpdateItemData}>
              <div className="modal-body pb-0">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        name="category_name"
                        value={newItem.category_name}
                        onChange={getInputData}
                        className="form-control"
                        placeholder="Goal Profile Name...."
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Description<span className="text-danger">*</span>
                      </label>
                      <textarea
                        name="description"
                        value={newItem.description}
                        onChange={getInputData}
                        className="form-control"
                        placeholder="Description...."
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  data-bs-dismiss="modal"
                  className="btn btn-primary custom_button"
                >
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default PMSCategory;



// OLD CODE
// import React, { useEffect, useRef, useState } from "react";
// import { Link } from "react-router-dom";
// import { all_routes } from "../router/all_routes";
// import CollapseHeader from "../../core/common/collapse-header/collapse-header";
// import Table from "../../core/common/dataTable/index";
// import DeleteModal from "../../core/modals/deleteModal";
// import useApi from "../../core/customhook/useApi";
// import Swal from "sweetalert2";

// const PMSCategory = () => {
//   const [allItemList, setAllItemList] = useState<any[]>([]);
//   const [count, setCount] = useState(1);
//   const [newItem, setNewItem] = useState<any>({
//     category_id: "",
//     category_name: "",
//     description: "",
//   });

//   const getInputData = (e: any) => {
//     const { name, value } = e.target;
//     setNewItem({ ...newItem, [name]: value });
//   };
//   const formatFinancialYear = (year: number) => {
//     const nextYearShort = (year + 1).toString().slice(-2);
//     return `${year}-${nextYearShort}`;
//   };

//   const getCurrentFinancialYear = () => {
//     const today = new Date();
//     const year = today.getFullYear();
//     const month = today.getMonth();
//     const fyStart = month >= 3 ? year : year - 1;
//     return formatFinancialYear(fyStart);
//   };
//   const [finance_year, setFinance_year] = useState(getCurrentFinancialYear());
//   const [selectedItem, setSelectedItem] = useState<any>({});
//   const [errors, setErrors] = useState<any>({});

//   const columns = [
//     {
//       title: "SrNo.",
//       dataIndex: "SrNo",
//       render: (text: string, record: any, index: number) => (
//         <h6 className="fw-medium fs-14 text-dark">{index + 1}</h6>
//       ),
//       sorter: false,
//     },
//     {
//       title: "Category",
//       dataIndex: "category_name",
//       render: (text: string, record: any, index: number) => <p>{text}</p>,
//       sorter: (a: any, b: any) => a.category.localeCompare(b.category),
//     },
//     {
//       title: "Description",
//       dataIndex: "category_description",
//       sorter: (a: any, b: any) => a.description.localeCompare(b.description),
//     },
//     {
//       title: "CreatedBy",
//       dataIndex: "manager_id",
//       sorter: (a: any, b: any) => a.createdBy.localeCompare(b.createdBy),
//     },
//     {
//       title: "CreatedDate",
//       dataIndex: "created_at",
//       render: (text: string, record: any) => (
//         <span className={``} style={{ width: "120px" }}>
//           {text.split("T")[0]}
//         </span>
//       ),
//       sorter: (a: any, b: any) =>
//         new Date(a.createdDate || 0).getTime() -
//         new Date(b.createdDate || 0).getTime(),
//     },
//     {
//       title: "Action",
//       dataIndex: "actions",
//       render: (_: any, record: any) => (
//         <div className="action-icon d-inline-flex">
//           <Link
//             to="#"
//             className="me-2"
//             data-bs-toggle="modal"
//             data-bs-target="#edit_category"
//             onClick={() => {
//               setNewItem({
//                 category_id: record.category_id,
//                 category_name: record.category_name,
//                 description: record.category_description,
//               });
//             }}
//           >
//             <i className="ti ti-edit" />
//           </Link>
//           <Link
//             to="#"
//             className="me-2"
//             onClick={() => {
//               DeleteItem(record.category_id);
//             }}
//           >
//             <i className="ti ti-trash" />
//           </Link>
//         </div>
//       ),
//     },
//   ];

//   const {
//     data: getcategoryResponse,
//     loading: getCategoryLoading,
//     error: getCategoryError,
//   } = useApi("/api/manager/view-category", {
//     method: "POST",
//     payload: {
//       financial_year: finance_year,
//     },
//     autoCall: true,
//     dependencies: [count],
//   });

//   useEffect(() => {
//     setAllItemList(getcategoryResponse?.data);
//   }, [getcategoryResponse]);

//   const {
//     data: categoryResponse,
//     loading: postCategoryLoading,
//     error: postCategoryError,
//     callApi: postCategoryData,
//   } = useApi("/api/manager/add-category", {
//     method: "POST",
//     autoCall: false,
//   });

//   const AddNewItem = async (e: any) => {
//     e.preventDefault();
//     const payload = {
//       category_name: newItem.category_name,
//       category_description: newItem.description,
//     };
//     try {
//       const response = await postCategoryData(payload);
//       if (response.success) {
//         Swal.fire({
//           title: "Success!",
//           text: response?.message || "Category has been added successfully.",
//           icon: "success",
//           confirmButtonText: "OK",
//         });
//         document.getElementById("close_modal")?.click();
//         setCount(count + 1);
//         setNewItem({
//           category_id: "",
//           category_name: "",
//           description: "",
//         });
//       }
//     } catch (error) {
//       console.error("Error while adding :", error);
//       Swal.fire({
//         title: "Error!",
//         text: "There was a problem adding the category.",
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     }
//   };

//   const {
//     data: editcategoryResponse,
//     loading: editCategoryLoading,
//     error: editCategoryError,
//     callApi: editCategoryData,
//   } = useApi("/api/manager/edit-category", {
//     method: "POST",
//     autoCall: false,
//   });

//   const UpdateItemData = async (e: any) => {
//     e.preventDefault();
//     const payload = {
//       category_id: newItem.category_id,
//       category_name: newItem.category_name,
//       category_description: newItem.description,
//     };
//     try {
//       const response = await editCategoryData(payload);
//       if (response.success) {
//         Swal.fire({
//           title: "Success!",
//           text: response?.message || "Category has been update successfully.",
//           icon: "success",
//           confirmButtonText: "OK",
//         });
//         document.getElementById("edit_close_modal")?.click();
//         setCount(count + 1);
//       }
//     } catch (error) {
//       console.error("Error while updating :", error);
//       Swal.fire({
//         title: "Error!",
//         text: "There was a problem adding the category.",
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     }
//   };

//   const {
//     data: deletecategoryResponse,
//     loading: deleteCategoryLoading,
//     error: deleteCategoryError,
//     callApi: deleteCategoryData,
//   } = useApi("", {
//     method: "DELETE",
//     autoCall: false,
//   });
//   const DeleteItem = async (ID: any) => {
//     const confirmResult = await Swal.fire({
//       title: "Are you sure?",
//       text: "Do you really want to delete this category? This action cannot be undone.",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#d33",
//       cancelButtonColor: "#3085d6",
//       confirmButtonText: "Yes, delete it!",
//       cancelButtonText: "Cancel",
//     });

//     if (confirmResult.isConfirmed) {
//       try {
//         const response = await deleteCategoryData(
//           undefined,
//           "/api/manager/delete-category/" + ID
//         );

//         if (response.success) {
//           Swal.fire({
//             title: "Deleted!",
//             text:
//               response?.message || "Category has been deleted successfully.",
//             icon: "success",
//             confirmButtonText: "OK",
//           });
//           setCount(count + 1);
//         }
//       } catch (error) {
//         console.error("Error while deleting:", error);
//         Swal.fire({
//           title: "Error!",
//           text: "There was a problem deleting the category.",
//           icon: "error",
//           confirmButtonText: "OK",
//         });
//       }
//     }
//   };

//   return (
//     <>
//       {/* Page Wrapper */}
//       <div className="page-wrapper">
//         <div className="content">
//           {/* Breadcrumb */}
//           <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
//             <div className="my-auto mb-2">
//               <h2 className="mb-1">Goal Profiles</h2>
//               <nav>
//                 <ol className="breadcrumb mb-0">
//                   <li className="breadcrumb-item">
//                     <Link to={all_routes.adminDashboard}>
//                       <i className="ti ti-smart-home" />
//                     </Link>
//                   </li>
//                   <li className="breadcrumb-item">Dashboard</li>
//                   <li className="breadcrumb-item active" aria-current="page">
//                     All Goal Profiles
//                   </li>
//                 </ol>
//               </nav>
//             </div>
//             <div className="d-flex my-xl-auto right-content align-items-center flex-wrap gap-2">
//               <div className="input-icon w-120 position-relative mb-2">
//                 <select
//                   value={finance_year}
//                   onChange={(e) => setFinance_year(e.target.value)}
//                   className="form-select"
//                 >
//                   {(() => {
//                     const today = new Date();
//                     const currentYear =
//                       today.getMonth() >= 3
//                         ? today.getFullYear()
//                         : today.getFullYear() - 1;

//                     return Array.from({ length: 1 }, (_, i) => {
//                       const year = currentYear - i;
//                       const nextYearShort = String(year + 1).slice(-2);
//                       const financialYear = `${year}-${nextYearShort}`;

//                       return (
//                         <option key={financialYear} value={financialYear}>
//                           {financialYear}
//                         </option>
//                       );
//                     });
//                   })()}
//                 </select>
//               </div>
//               <div className="mb-2">
//                 <Link
//                   to="#"
//                   data-bs-toggle="modal"
//                   data-bs-target="#add_category"
//                   className="btn btn-primary d-flex align-items-center"
//                 >
//                   <i className="ti ti-circle-plus me-2" />
//                   Add Category
//                 </Link>
//               </div>
//             </div>
//           </div>
//           {/* /Breadcrumb */}
//           {/* Performance Indicator list */}
//           <div className="card">
//             <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
//               <h5>Category List</h5>
//             </div>
//             <div className="card-body p-0">
//               <Table
//                 dataSource={allItemList}
//                 columns={columns}
//                 Selection={false}
//               />
//             </div>
//           </div>
//           {/* /Performance Indicator list */}
//         </div>
//         <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
//           <p className="mb-0">
//             © {new Date().getFullYear()} WeConnect. All rights reserved.
//           </p>
//         </div>
//       </div>
//       {/* /Page Wrapper */}

//       {/* Add Modal */}
//       <div className="modal fade" id="add_category">
//         <div className="modal-dialog modal-dialog-centered modal-md">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h4 className="modal-title text-capitalize">Add Category</h4>
//               <button
//                 type="button"
//                 className="btn-close custom-btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//                 id="close_modal"
//               >
//                 <i className="ti ti-x" />
//               </button>
//             </div>
//             <form onSubmit={AddNewItem}>
//               <div className="modal-body pb-0">
//                 <div className="row">
//                   <div className="col-md-12">
//                     <div className="mb-3">
//                       <label className="form-label">
//                         Category Name<span className="text-danger">*</span>
//                       </label>
//                       <input
//                         type="text"
//                         name="category_name"
//                         onChange={getInputData}
//                         value={newItem.category_name}
//                         className="form-control"
//                         placeholder="Category Name...."
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-12">
//                     <div className="mb-3">
//                       <label className="form-label">
//                         Description<span className="text-danger">*</span>
//                       </label>
//                       <textarea
//                         name="description"
//                         onChange={getInputData}
//                         value={newItem.description}
//                         className="form-control"
//                         placeholder="Description...."
//                       ></textarea>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               <div className="modal-footer">
//                 <button
//                   type="button"
//                   className="btn btn-light me-2"
//                   data-bs-dismiss="modal"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   // data-bs-dismiss="modal"
//                   className="btn btn-primary"
//                 >
//                   Add Category
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>

//       {/* Edit Modal */}
//       <div className="modal fade" id="edit_category">
//         <div className="modal-dialog modal-dialog-centered modal-md">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h4 className="modal-title text-capitalize">Edit Category</h4>
//               <button
//                 type="button"
//                 className="btn-close custom-btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//                 id="edit_close_modal"
//               >
//                 <i className="ti ti-x" />
//               </button>
//             </div>
//             <form onSubmit={UpdateItemData}>
//               <div className="modal-body pb-0">
//                 <div className="row">
//                   <div className="col-md-12">
//                     <div className="mb-3">
//                       <label className="form-label">
//                         Category Name <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         type="text"
//                         name="category_name"
//                         value={newItem.category_name}
//                         onChange={getInputData}
//                         className="form-control"
//                         placeholder="Category Name...."
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-12">
//                     <div className="mb-3">
//                       <label className="form-label">
//                         Description<span className="text-danger">*</span>
//                       </label>
//                       <textarea
//                         name="description"
//                         value={newItem.description}
//                         onChange={getInputData}
//                         className="form-control"
//                         placeholder="Description...."
//                       ></textarea>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="modal-footer">
//                 <button
//                   type="button"
//                   className="btn btn-light me-2"
//                   data-bs-dismiss="modal"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   data-bs-dismiss="modal"
//                   className="btn btn-primary"
//                 >
//                   Save Changes
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default PMSCategory;
